import { firebase } from "@data/firebase/config";
import { Client } from "@domain/models/Client";
import { Paging } from "@domain/models/Paging";
import {
  collection,
  getCountFromServer,
  limit,
  onSnapshot,
  orderBy,
  query,
} from "firebase/firestore";
import { fireabseAdapter } from "./firebaseAdapter";
import { DatabaseClientRepository } from "@domain/repositories/DatabaseClientRepository";
import { ClientStore } from "@domain/stores/ClientStore";

export class FirebaseClientRepository implements DatabaseClientRepository {
  constructor(private readonly clientStore: ClientStore) {}

  watchAllClientsAdmin(paging: Paging) {
    const consulta = query(
      collection(firebase.db, "clients"),
      orderBy("updatedAt", "desc"),
      limit(paging.limit)
    );

    onSnapshot(
      consulta,
      async (querySnapshot) => {
        const mappedDocs = fireabseAdapter.mapFirebaseDoc<Client>(querySnapshot);

        const allDocsCount = await getCountFromServer(query(collection(firebase.db, "clients")));
        this.clientStore.updateAllClients(mappedDocs, allDocsCount.data().count);
      },
      (error) => console.log("watchAllClientsAdmin error", error)
    );
  }
}
